import { render, staticRenderFns } from "./ColumnsPanel.vue?vue&type=template&id=1cc6e129&"
import script from "./ColumnsPanel.vue?vue&type=script&lang=js&"
export * from "./ColumnsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports